<div class="custom-tooltip">
        {{ params?.value}}
</div>